import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "camp", "amount", "redemptionLimit", "discountCodes", "message", "submit"]

  connect() {
    if (process.env.NODE_ENV === 'development') {
      console.log("Camp Credit Form Controller connected");
    }
    this.validateForm();
  }

  validateForm() {
    const titleValid = this.titleTarget.value.trim() !== "";
    const campValid = this.campTarget.value !== "";
    const amountValue = this.amountTarget.value.trim();
    let amountValid = amountValue !== "" && Number(amountValue) > 0;

    const discountCodeInputs = this.discountCodesTarget.querySelectorAll(".discount-code-input");
    let discountCodeValid = false;
    discountCodeInputs.forEach(input => {
      if (input.value.trim() !== "") {
        discountCodeValid = true;
      }
    });

    let message = "";
    if (!titleValid) {
      message += this.element.dataset.titleRequiredMessage || "Please enter a title. ";
    }
    if (!campValid) {
      message += this.element.dataset.campRequiredMessage || "Please select a camp. ";
    }
    if (!amountValid) {
      message += this.element.dataset.amountRequiredMessage || "Please enter a valid amount greater than 0. ";
    }
    if (!discountCodeValid) {
      message += this.element.dataset.codeRequiredMessage || "At least one active discount code is required. ";
    }

    this.messageTarget.textContent = message;

    const infoBox = this.messageTarget.closest('.info-box');
    if (message.trim() === "") {
      infoBox.classList.add("hidden");
    } else {
      infoBox.classList.remove("hidden");
    }

    if (message.trim() === "") {
      this.messageTarget.classList.remove("error");
      this.messageTarget.classList.add("valid");
    } else {
      this.messageTarget.classList.remove("valid");
      this.messageTarget.classList.add("error");
    }

    this.submitTarget.disabled = !(titleValid && campValid && amountValid && discountCodeValid);
  }
}
